import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import Institute_PGscholarshipsEle from '../Scholarships/Institute_PGscholarshipsEle'


function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Scholarship" />
            <Institute_PGscholarshipsEle />
        </>
    )
}

export default Main